import { TReferralUserStatsKey } from '~/components/Referral/types/referral-summary.types';
import { TFuncKey } from 'react-i18next';
import { NAMESPACES } from '~/i18n/namespaces';

export const REFERRAL_STATS_TRANSLATION_KEYS: Record<
    TReferralUserStatsKey,
    TFuncKey<typeof NAMESPACES.REFERRAL, 'summary.stats'>
> = {
    totalSum: 'your_earnings',
    numberOfTrialers: 'started_trial',
    numberOfSubscribers: 'subscribed',
    numberOfEligibles: 'eligibles'
};

export const REFERRAL_QUERY_PARAMS = {
    SOURCE: 'source',
    ACTION_TYPE: 'action_type'
};

export const ELIGIBILITY_DAYS = 100;
export const ELIGIBILITY_DAYS_LOCK_WINDOW = 180;
